export enum activityLogActionTypes {
    LOG_BEGIN = "LOG_BEGIN",
    LOG_ERROR = "LOG_ERROR",
    LOG_SUCCESS = "LOG_SUCCESS",

    COUNT_RECORDS_BEGIN = "COUNT_RECORDS_BEGIN",
    COUNT_RECORDS_ERROR = "COUNT_RECORDS_ERROR",
    COUNT_RECORDS_SUCCESS = "COUNT_RECORDS_SUCCESS"
}